import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleChipComponentModule } from '@accredible-frontend-v2/new-components/chip';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import {
  AccredibleListComponentModule,
  AccredibleListItemComponentModule,
} from '@accredible-frontend-v2/new-components/list';
import { AccredibleTileComponentModule } from '@accredible-frontend-v2/new-components/tile';
import { AccredibleTruncateTextComponentModule } from '@accredible-frontend-v2/new-components/truncate-text';
import { ShowMoreDirective } from '@accredible-frontend-v2/new-components/ui-common';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Directory } from '@directory-of-directories/domain';
import { MembersCountComponent } from '../members-count/members-count.component';
import { OpenDirectoryButtonComponent } from '../open-directory-btn/open-directory-btn.component';

@Component({
  standalone: true,
  selector: 'accredible-directory-list-item',
  templateUrl: `./directory-list-item.component.html`,
  styleUrls: ['./directory-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    CdkMenuModule,
    A11yModule,
    AccredibleTileComponentModule,
    AccredibleChipComponentModule,
    AccredibleButtonComponentModule,
    AccredibleIconComponentModule,
    AccredibleListComponentModule,
    AccredibleListItemComponentModule,
    AccredibleTruncateTextComponentModule,
    OpenDirectoryButtonComponent,
    MembersCountComponent,
    ShowMoreDirective,
  ],
})
export class DirectoryListItemComponent {
  directory = input<Directory>();
  isLoading = input(false);

  readonly NUM_CATEGORIES_ON_CARD = 3;

  readonly DESCRIPTION_SHOW_MORE_THRESHOLD = 150;
}
